const wowApp = require('angular').module('wowApp.shop');

wowApp.service('CatalogService', ['Restangular', require('./catalog-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/catalog/index.js
 **/